const THEME_PREFIX = 'theme_';

module.exports = {
    THEME_PREFIX
}